<template>
  <div class="module-container">
    <div class="title">证件信息</div>
    <ul class="infos">
      <li class="info-item">
        <div class="name">车牌</div>
        <div class="value">{{ infos.permitPlate }}</div>
      </li>
      <li class="info-item">
        <div class="name">车辆类型</div>
        <div class="value">{{ infos.carModel }}</div>
      </li>
      <li class="info-item">
        <div class="name">所有人</div>
        <div class="value">{{ infos.owner }}</div>
      </li>
      <li class="info-item">
        <div class="name">使用性质</div>
        <div class="value">{{ formatUseTypeText(infos.useType) }}</div>
      </li>
      <li class="info-item">
        <div class="name">品牌型号</div>
        <div class="value">{{ infos.brandType }}</div>
      </li>
      <li class="info-item">
        <div class="name">行驶证状态</div>
        <div class="value">{{ infos.permitState }}</div>
      </li>
      <li class="info-item">
        <div class="name">检验有效期</div>
        <div class="value">{{ infos.checkValidity }}</div>
      </li>
      <li class="info-item">
        <div class="name">有效期限（止）</div>
        <div class="value">{{ infos.endValidity }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    infos: {
      type: Object,
      default: () => {
        return {
          permitPlate: '',
          carModel: '',
          owner: '',
          useType: '',
          brandType: '',
          permitState: '',
          checkValidity: '',
          endValidity: ''
        }
      }
    }
  },
  methods: {
    formatUseTypeText(val) {
      if (val == 1) {
        return '商用营运'
      } else if (val == 2) {
        return '公用营运'
      } else if (val == 3) {
        return '非营运'
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.module-container {
  padding 30px
  font-family PingFangSC-Semibold, PingFang SC
  font-weight 400
  .title {
    height 53px
    font-size 38px
    font-weight 600
    color #333333
    line-height 53px
    padding-left 20px
    position relative
    z-index 5
    &::before {
      z-index -1
      position absolute
      content ''
      left 0
      top 50%
      transform translateY(-50%)
      width 36px
      height 36px
      border-radius 50%
      background linear-gradient(270deg, #DBEBFF 0%, #7DB7FF 100%)
    }
  }
  .infos {
    .info-item {
      display flex
      justify-content space-between
      align-items center
      padding 30px 0
      font-size 30px
      line-height 42px
      .name {
        width 210px
        margin-right 50px
        color #333333
      }
      .value {
        text-align right
        flex 1
        color #999999
      }
    }
    .info-item+.info-item {
      border-top 1px solid #ECECEC
    }
  }
}
</style>
